import React from 'react'

export const IconAddImg = ({ color = '#757575' }) => (
  <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H11.09C11.03 17.67 11 17.34 11 17C11 16.32 11.12 15.64 11.35 15H2L5.5 10.5L8 13.5L11.5 9L13.73 11.97C14.7 11.34 15.84 11 17 11C17.34 11 17.67 11.03 18 11.09V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H2ZM16 13V16H13V18H16V21H18V18H21V16H18V13H16Z' fill={color} />
  </svg>
)
